export default __webpack_public_path__ + "static/media/frame1.bc72ea78.png";